































































































import Openable from '@/global/viewmodels/openable'
import mobileTypeMixin from '@/plugins/mixins/mobileTypeMixin'
import mixins from 'vue-typed-mixins'
import globalMixin from '../globalMixin'
import suiviRecueilChartMixin from './SuiviRecueilChartMixin'
import suiviRecueilDatatableMixin from './SuiviRecueilDatatableMixin'

export default mixins(globalMixin, mobileTypeMixin, suiviRecueilChartMixin, suiviRecueilDatatableMixin).extend({
    components: {
        BAlert: () => import('@/layout/components/BiobankAlert.vue'),
    },
    data() {
        return {
            alert: new Openable(),
            companyName: '',
            dateDebut: `${new Date().getFullYear()}-01-01`,
            dateFin: '',
        }
    },
    methods: {
        onCompanyChange() {
            this.reload()
        },
        reload() {
            this.reloadChart(this.chirurgien)
            this.reloadDatatable()
        }, 
    },
    mounted() {
        this.alert.open()
    },
    watch : {
        "chirurgien" : function() {
            this.reloadChart(this.chirurgien)
        }
    }
})
